import {useDroppable} from "@dnd-kit/core";
import {ReactNode} from "react";

interface DroppableListProps {
    id: string;
    children: ReactNode;
    className?: string;
}

export function DroppableList({
    id,
    children,
    className = "",
}: DroppableListProps) {
    const {setNodeRef, isOver} = useDroppable({id});

    return (
        <div
            ref={setNodeRef}
            className={`${className} ${
                isOver ? "bg-emerald-50" : ""
            }`}
        >
            {children}
        </div>
    );
}
